export const eAsigSteps = [
  { 1: 'step_1' },
  { 2: 'step_2' },
  { 3: 'step_3' },
  { 4: 'step_4' },
];

// REGEX
export const LATIN_REGEX = /^[A-Za-zȘȚÎĂÂșțăîâа-яА-ЯёЁ\s]+$/;
export const NUMBER_REGEX = /^[0-9]+$/;
export const MAIL_REGEX = /^[a-z0-9_/-]+\.?[a-z0-9]+@{1}[a-z0-9.]*\.[a-z]{2,5}$/;
export const PASSPORT_REGEX = /^[A-Z][0-9]*$/;
